<eon-ui-icon class="cursor-pointer" name="share" (click)="shareOp.toggle($event)"></eon-ui-icon>

<p-popover #shareOp>
    <eon-ui-button size="small" scheme="turquoise" text="Copy Link" [cdkCopyToClipboard]="link"
        (cdkCopyToClipboardCopied)="onClipboardCopy($event)"></eon-ui-button>
    <qr-code value="{{link}}" size="180" errorCorrectionLevel="M"></qr-code>
</p-popover>
